import React, { useLayoutEffect, useRef } from 'react';
import { Link, useParams } from 'react-router-dom';
import SeoHead from '@components/SeoHead';
import { getGuideBySlug } from '@lib/content';
import { decodeHtml } from '@lib/seo';
import { siteConfig } from '../config';

function wrapGuideTables(root: HTMLElement) {
  root.querySelectorAll('table').forEach((table) => {
    if (table.closest('.guide-table-wrap')) return;

    const wrap = document.createElement('div');
    wrap.className = 'guide-table-wrap';
    table.parentNode?.insertBefore(wrap, table);
    wrap.appendChild(table);
  });
}

const GuidePage: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const guide = slug ? getGuideBySlug(slug) : undefined;
  const contentRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const root = contentRef.current;
    if (!root) return;

    wrapGuideTables(root);
  }, [guide?.intro, guide?.content]);

  if (!guide) {
    return (
      <div className="container" style={{ paddingTop: '2rem', position: 'relative', zIndex: 1 }}>
        <p className="muted">Guide not found.</p>
        <Link to="/">Back to home</Link>
      </div>
    );
  }

  return (
    <>
      <SeoHead title={guide.title} description={guide.description} pageSlug={`guides/${guide.slug}`} />
      <div className="container" style={{ paddingTop: '2rem', position: 'relative', zIndex: 1 }}>
        <article className="info-the-game">
          <div className="game-breadcrumb" style={{ marginBottom: '1rem' }}>
            <Link to="/">{siteConfig.siteName}</Link>
            <span className="separator">›</span>
            <span>Guides</span>
            <span className="separator">›</span>
            <span>{guide.title}</span>
          </div>
          <h1 className="game-meta-title" style={{ marginBottom: '1rem' }}>{guide.title}</h1>
          <div className="guide-detail-content" ref={contentRef}>
            {guide.intro && (
              <div dangerouslySetInnerHTML={{ __html: decodeHtml(guide.intro) }} />
            )}
            <div dangerouslySetInnerHTML={{ __html: decodeHtml(guide.content) }} />
          </div>
        </article>
      </div>
    </>
  );
};

export default GuidePage;
